export default __webpack_public_path__ + "static/media/lahore.1ab6f5cd.jpg";